module.exports = __webpack_public_path__ + "img/1Pro3-2@2x.84af575b.png";